const state = {
  dataADConf: {},
  layoutADConf: {},
  meanADConf: -1,
  t1ADConf: -1,
  t2ADConf: -1
}

const getters = {
  getDataADConf: state => state.dataADConf,
  getLayoutADConf: state => state.layoutADConf,
  getMeanADConf: state => state.meanADConf,
  getT1ADConf: state => state.t1ADConf,
  getT2ADConf: state => state.t2ADConf
}

const actions = {
  setPlotADConf ({ commit }, { data, layout }) {
    commit('SET_DATA_ADConf', data)
    commit('SET_LAYOUT_ADConf', layout)
  },
  setMeanADConf ({ commit }, newMean) {
    newMean = Math.abs(newMean)// Always positive
    newMean = Math.round(newMean * 10) / 10// Round one decimals
    commit('SET_MEAN_ADConf', newMean)
  },
  setT1ADConf ({ commit }, t1) {
    t1 = Math.abs(t1)// Always positive
    t1 = Math.round(t1 * 100) / 100 // Round two decimals
    commit('SET_T1_ADConf', t1)
  },
  setT2ADConf ({ commit }, t2) {
    t2 = Math.abs(t2)// Always positive
    t2 = Math.round(t2 * 100) / 100 // Round two decimals
    commit('SET_T2_ADConf', t2)
  }
}

const mutations = {
  SET_DATA_ADConf: (state, dataADConf) => (state.dataADConf = dataADConf),
  SET_LAYOUT_ADConf: (state, layoutADConf) => (state.layoutADConf = layoutADConf),
  SET_MEAN_ADConf: (state, mean) => (state.meanADConf = mean),
  SET_T1_ADConf: (state, t1) => (state.t1ADConf = t1),
  SET_T2_ADConf: (state, t2) => (state.t2ADConf = t2)
}

export default {
  state,
  getters,
  actions,
  mutations
}
